import { render } from "./Stillvorbereitung.vue?vue&type=template&id=fd535c40&scoped=true"
import script from "./Stillvorbereitung.vue?vue&type=script&lang=js"
export * from "./Stillvorbereitung.vue?vue&type=script&lang=js"

import "./Stillvorbereitung.vue?vue&type=style&index=0&id=fd535c40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd535c40"]])

export default __exports__